import type { HeaderBird, SeasonalHeaderBird } from '~/index'

export type { HeaderBird, SeasonalHeaderBird }

const STANDARD_HEADER_BIRD: HeaderBird = {
  src: '/images/bird.svg',
  width: 30,
  height: 38,
}

// First match wins. A window may cross New Year (start month after end month).
export function resolveHeaderBird(
  date: Date,
  seasons: readonly SeasonalHeaderBird[],
  timeZone: string,
): HeaderBird {
  const { month, day } = monthAndDayInTimeZone(date, timeZone)
  return seasons.find(season => isWithinSeason(month, day, season)) ?? STANDARD_HEADER_BIRD
}

function isWithinSeason(month: number, day: number, season: SeasonalHeaderBird): boolean {
  const current = month * 100 + day
  const start = season.start.month * 100 + season.start.day
  const end = season.end.month * 100 + season.end.day
  if (start <= end)
    return current >= start && current <= end
  return current >= start || current <= end
}

function monthAndDayInTimeZone(date: Date, timeZone: string): { month: number, day: number } {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone,
    month: 'numeric',
    day: 'numeric',
  }).formatToParts(date)

  const month = Number(parts.find(part => part.type === 'month')?.value)
  const day = Number(parts.find(part => part.type === 'day')?.value)
  return { month, day }
}
